module.exports = __webpack_public_path__ + "img/ico-hey.f3dc8868.svg";